<template>
  <div id="pageRoot">
    <p class="textBase" style="position: absolute; width: 480px; font-size: 26px; top: 50px; left: 570px; text-align: left;">
		"LO TIENE ESCONDIDO<br>LA MAMÁ CHICHARRA"<br>VIBRA ENTRE LOS MIMBRES,<br>PERO ¿QUIÉN LO AGARRA?<br><br>QUISE EL VIOLÍN VERDE<br>-MÚSICA DE LUNA-<br>PARA DAR EL SUEÑO<br>AL QUE ESTÁ EN LA CUNA.<br><br>TÓMALO GRILLITO,<br>Y CÁNTALE AL RÍO,<br>DORMIRÁS TAMBIÉN<br>AL PEQUEÑO MÍO.
    </p>

    <img src="/pages/img/sordovio/assets_p4/arbol.svg" style="position: absolute; width: 90px; top: 210px; left: 320px; z-index: 3"/>

    <img src="/pages/img/sordovio/assets_p4/nube0.svg" style="position: absolute; width: 500px; top: 70px; left: 60px; z-index: 0"  class="slideItemB"/>
    <img src="/pages/img/sordovio/assets_p4/nube1.svg" style="position: absolute; width: 300px; top: 200px; left: 60px; z-index: 1"  class="slideItem"/>
    <img src="/pages/img/sordovio/assets_p4/piso.svg" style="position: absolute; width: 950px; top: 400px; left: 20px; z-index: 0"/>
    <img src="/pages/img/sordovio/assets_p4/tero.svg" style="position: absolute; width: 300px; top: 430px; left: 260px; z-index: 1"  class="bouncingItemB"/>
  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 37px;
    top: 58px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 6.mp4",
        "vio/Video 7.mp4",
        "vio/Video 8b.mp4",
        ]
    }
  }
}
</script>